import Chip from '@mui/material/Chip';

import { useTranslate } from 'src/locales';

import { Iconify } from 'src/components/iconify';

import type { CSATSurveySource } from '../slice/csatTypes';

// ----------------------------------------------------------------------

type CsatSourceBadgeProps = {
  source: CSATSurveySource | null | undefined;
  size?: 'small' | 'medium';
};

export function CsatSourceBadge({ source, size = 'small' }: CsatSourceBadgeProps) {
  const { t } = useTranslate('translation');

  if (!source) {
    return (
      <Chip
        size={size}
        label={t('CSAT_SOURCE_UNKNOWN')}
        variant="outlined"
        sx={{ color: 'text.secondary', borderColor: 'divider' }}
      />
    );
  }

  if (source === 'manual') {
    return (
      <Chip size={size} label={t('CSAT_SOURCE_CUSTOMER')} color="info" variant="outlined" />
    );
  }

  if (source === 'ai_voice') {
    return (
      <Chip
        size={size}
        icon={<Iconify icon="mdi:phone-outline" width={16} />}
        label={t('CSAT_SOURCE_AI_VOICE')}
        color="secondary"
        variant="outlined"
      />
    );
  }

  return (
    <Chip size={size} label={t('CSAT_SOURCE_AI')} color="secondary" variant="outlined" />
  );
}
